import { render, staticRenderFns } from "./Forklift.vue?vue&type=template&id=792a64b0&scoped=true&"
import script from "./Forklift.vue?vue&type=script&lang=js&"
export * from "./Forklift.vue?vue&type=script&lang=js&"
import style0 from "./Forklift.vue?vue&type=style&index=0&id=792a64b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792a64b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VContainer,VIcon})
